module.exports = __webpack_public_path__ + "static/media/webVideo.319ee7f5.svg";